export const LOCAL_AUTH_STATE_KEY = "authState";
